  // Custom script developed by Columbus

  // PDP highlights accordian click event
  const productHighlight_btn = document.querySelector('.c-product__highlight-title');
  productHighlight_btn.addEventListener('click', function () {
   this.classList.toggle('active');
  });